import React, {Component} from 'react';
import enumEdades from "../../Enums/edades";
import enumTamanios from "../../Enums/tamanios";
import SimpleSelect from "../../../Shared/components/Forms/selects/SimpleSelect";
import {
    loadCaractersAnimal,
    loadColoresAnimal,
    loadEdadesAnimal,
    loadEstadosAnimal,
    loadRaza,
    loadTamaniosAnimal
} from '../../../AnimalList/actions/actionsFilterAnimals';
import MultiSelect from "../../../Shared/components/Forms/selects/MultiSelect";
import NewMultiSelect from "../../../Shared/components/Forms/selects/NewMultiSelect";
import SelectRadioGroup from "../../../Shared/components/Forms/selects/SelectRadioGroup";
import SwitchButton from "../../../Shared/components/Forms/SwitchButton";
import Input from "../../../Shared/components/Forms/input/input";
import InputTextarea from "../../../Shared/components/Forms/input/InputTextarea";
import Datepicker from "../../../Shared/components/Forms/date-picker";
// import {changeEspecieInfoAnimalDetail, resetInfoAnimalDetail} from '../../../actions/actionsAnimalList';
import Alert from "react-s-alert";
import {browserHistory} from "react-router";
import ImageDragAndDrop from '../../../Shared/components/Forms/ImageDragAndDrop';
import {connect} from "react-redux";
import {PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID, PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN} from "../../../../App/RouterAdopta";

const IMAGES_ANIMALS_LIMIT = 6;

class FormInsertAnimalContainer extends Component {

    constructor(props) {
        super(props);

        this.state = this.loadState();

        this.descripcionTextArea = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            iconSpan: "icon-registro las la-file-alt",
            controlValidate: "",
            columns: "col-lg-12",
            id: "descripcion",
            formGroup: "",
            rows: "12",
            placeHolder: "Descripción",
            methodChange: this.changeDescripcion.bind(this)
        };

        this.configName = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "",
            iconSpan: "",
            columns: "col-lg-12",
            id: "name",
            type: "text",
            placeHolder: "*Nombre del animal",
            methodChange: this.changeName.bind(this)
        };


        this.configSelectRadioGroupEspecie = {
            mainId: "especie-filtro",
            mainLabel: "Especie",
            selected: this.state.especie,
            idDiv: "select-home-second",
            classDiv: "form-group",
            showLabel: false,
            infoSelect: [
                {
                    icon: "las la-lg la-dog",
                    id: "switch_Perro",
                    value: "perro",
                    label: "Perro",
                    name: "switch_raza"
                },
                {
                    icon: "las la-lg la-cat",
                    id: "switch_Gato",
                    value: "gato",
                    label: "Gato",
                    name: "switch_raza",
                }
            ],
            methodChange: this.changeEspecie.bind(this)
        };

        this.configRazasMultiselect = {
            id: "razas",
            idSelect: "raza",
            collSize: "",
            seleccionado: this.state.raza,
            limit: 3,
            placeHolder: "Escribe y busca razas",
            methodChange: this.changeRaza.bind(this)
        };

        this.configEstado = {
            id: "",
            idSelect: "estados",
            collSize: "",
            seleccionado: this.state.estado,
            placeHolder: "Estados",
            methodChange: this.changeEstado.bind(this)
        };

        this.configEmailAdoptante = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "",
            iconSpan: "",
            columns: "col-lg-12",
            id: "email_adoptante",
            type: "text",
            placeHolder: "*Email de la persona adoptante",
            methodChange: this.changeEmailAdoptante.bind(this)
        };
        this.configEmailAcogido = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "",
            iconSpan: "",
            columns: "col-lg-12",
            id: "email_acogido",
            type: "text",
            placeHolder: "*Email de la persona de acogida",
            methodChange: this.changeEmailAcogido.bind(this)
        };

        this.configEdad = {
            id: "",
            idSelect: "edad",
            collSize: "",
            seleccionado: new enumEdades().convertir(this.state.edad),
            placeHolder: "Edad",
            methodChange: this.changeEdad.bind(this)
        };

        this.configColores = {
            id: "colorId",
            idSelect: "color",
            collSize: "",
            seleccionado: this.state.color,
            limit: 4,
            placeHolder: "Selecciona color",
            methodChange: this.changeColores.bind(this)
        };

        this.configSelectRadioGroupSexo = {
            mainId: "sexo-filter",
            mainLabel: "Sexo",
            selected: this.state.sexo,
            idDiv: "select-home-second",
            classDiv: "form-group",
            showLabel: false,
            infoSelect: [
                {
                    icon: "la la-venus",
                    id: "switch_Hembra",
                    value: "H",
                    label: "Hembra",
                    name: "switch_sexo"
                },
                {
                    icon: "la la-mars",
                    id: "switch_Macho",
                    value: "M",
                    label: "Macho",
                    name: "switch_sexo"
                }
            ],
            methodChange: this.changeSexo.bind(this)
        };

        this.configTamanio = {
            id: "",
            idSelect: "tamanios",
            collSize: "",
            seleccionado: new enumTamanios().convertir(this.state.tamano),
            placeHolder: "Tamaños",
            methodChange: this.changeTamanio.bind(this)
        };

        this.configVacuna = {
            id: "vacuna",
            classMain: "",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.state.vacunas,
            methodChange: this.changeVacuna.bind(this)
        };

        this.configMestizo = {
            id: "mestizo",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.state.mestizo,
            methodChange: this.changeMestizo.bind(this)
        };

        this.configEsterilizado = {
            id: "esterilizado",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.state.esterilizado,
            methodChange: this.changeEsterilizado.bind(this)
        };

        this.configEnfermedades = {
            id: "enfermedades",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.state.enfermedades,
            methodChange: this.changeEnfermedades.bind(this)
        };

        this.configPPP = {
            id: "ppp",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.state.ppp,
            methodChange: this.changePPP.bind(this)
        };

        this.configChip = {
            id: "chip",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.state.chip,
            methodChange: this.changeChip.bind(this)
        };

        this.configCaracters = {
            id: "caracterId",
            idSelect: "caracter",
            collSize: "",
            seleccionado: this.state.caracter,
            limit: 4,
            placeHolder: "Selecciona carácter",
            methodChange: this.changeCaracters.bind(this)
        };

        // this.save = this.save.bind(this);
        this.insert = this.insert.bind(this);
        this.reset = this.reset.bind(this);
        this.goAnimalList = this.goAnimalList.bind(this);
        this.toggleModalEmailAdoptado = this.toggleModalEmailAdoptado.bind(this);
        this.toggleModalEmailAcogido = this.toggleModalEmailAcogido.bind(this);
        this.guardarEmailAdoptante = this.guardarEmailAdoptante.bind(this);
        this.guardarEmailAcogido = this.guardarEmailAcogido.bind(this);
        this.changeCheckinProtectora = this.changeCheckinProtectora.bind(this);
        this.imageChange = this.imageChange.bind(this);
        this.imageAnimalChange = this.imageAnimalChange.bind(this);
    }


    goAnimalList() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + this.props.access.id);
    }

    loadState() {
        console.log("FormInsertAnimalContainer::loadState()")
        // return Object.keys(this.props.infoAnimalDetail).length !== 0
        //     ? {...this.props.infoAnimalDetail, imagesAnimals: []}
        //     :
            return {
                insert: true,
                caracter: [],
                chip: false,
                color: [],
                descripcion: "",
                edad: "A",
                especie: "gato",
                estado: "En adopción",
                esterilizado: false,
                fecha_entrada_protectora: new Date(),
                fecha_registro: new Date(),
                galeria_imagenes: [],
                galeria_videos: [],
                mestizo: false,
                nombre: "",
                ppp: false,
                raza: [],
                sexo: "H",
                tamano: "M",
                vacunas: false,
                imageData: {},
                imagesAnimals: [],
                img_principal: undefined,
                email_adoptante: "",
                email_acogido: ""
            };
    }

    resetState() {
        console.log("FormInsertAnimalContainer::resetState()")
        this.setState({
            insert: true,
            caracter: [],
            chip: false,
            color: [],
            descripcion: "",
            edad: "A",
            especie: "gato",
            estado: "En adopción",
            esterilizado: false,
            fecha_entrada_protectora: new Date(),
            fecha_registro: new Date(),
            galeria_imagenes: [],
            galeria_videos: [],
            mestizo: false,
            nombre: "",
            ppp: false,
            raza: [],
            sexo: "H",
            tamano: "M",
            vacunas: false,
            imagesAnimals: [],
            img_principal: undefined,
            email_adoptante: "",
            email_acogido: ""

        })
        this.configMestizo.Seleccionado = false;
        this.configVacuna.Seleccionado = false;
        this.configEsterilizado.Seleccionado = false;
        this.configEnfermedades.Seleccionado = false;
        this.configPPP.Seleccionado = false;
        this.configChip.Seleccionado = false;
        // this.configEstadoUrgente.Seleccionado = false;
        if (this.configRazasMultiselect) {
            this.configRazasMultiselect.seleccionado = [];
        }
        if (this.configColores) {
            this.configColores.seleccionado = [];
        }
        if (this.configCaracters) {
            this.configCaracters.seleccionado = []
        }
    }

    changeDescripcion(value) {
        this.setState({
            descripcion: value
        });
    }

    changeName(value) {
        this.setState({
            nombre: value
        });
    }


    changeEspecie(especie) {
        //console.log("FormInsertAnimalContainer::changeEspecie(especie = " + especie + ")")
        console.log("FormInsertAnimalContainer::changeEspecie(" + especie + ")");
        this.setState({
            raza: [],
            especie: especie
        });
        this.configSelectRadioGroupEspecie.selected = especie
        this.configRazasMultiselect.seleccionado = [];
        // this.props.changeEspecieInfoAnimalDetail(especie, "animalsProtectora");
    }

    changeRaza(razas) {
        console.log("FormInsertAnimalContainer::changeRaza(razas = [" + razas + "])")
        const especieSeleccionada = this.state.especie
        const razasValues = this.props.razasAnimales[especieSeleccionada].filter(e => razas.includes(e.label)).map(e => e.value)
        console.log("FormInsertAnimalContainer::changeRaza -> razasValues = [" + razasValues + "])")
        this.setState({
            raza: razasValues
        })
    }

    changeEstado(estado) {
        this.setState({
            estado: estado[0]
        })

        if (estado.length > 0 && estado[0] === "Adoptado") {
            this.toggleModalEmailAdoptado()
        }

        if (estado.length > 0 && estado[0] === "Acogido") {
            this.toggleModalEmailAcogido()
        }
    }

    changeEmailAdoptante(value) {
        this.setState({
            email_adoptante: value
        });
    }

    changeEmailAcogido(value) {
        this.setState({
            email_acogido: value
        });
    }


    // changeEstadoUrgente(changeEstado) {
    //     this.configEstadoUrgente.Seleccionado = changeEstado;
    //     this.setState({
    //         changeEstado: changeEstado
    //     });
    // }

    changeEdad(edad) {
        this.setState({
            edad: new enumEdades().revertir(edad[0])
        });
    }

    changeColores(color) {
        this.setState({
            color: color
        });
    }

    changeSexo(sexo) {
        //console.log("FormInsertAnimalContainer::changeSexo(" + sexo + ")");
        this.setState({
            sexo: sexo
        }, () => {
            //console.log("state changed");
            // console.log("nextProps.sexo = '" + nextProps.sexo + "'");
            // console.log("nextState.sexo = '" + nextState.sexo + "'");
            // this.configSelectRadioGroupSexo = {
            //     ...this.configSelectRadioGroupSexo,
            //     selected: nextProps.sexo || nextState.sexo
            // };
            // this.state.sexo = nextState.sexo
        });
    }

    changeTamanio(tamanio) {
        let value = new enumTamanios().revertir(tamanio[0])
        this.setState({
            tamano: new enumTamanios().revertir(tamanio[0])
        });
    }

    changeVacuna(vacunas) {
        this.configVacuna.Seleccionado = vacunas;
        this.setState({
            vacunas: vacunas
        });
    }

    changeMestizo(mestizo) {
        this.configMestizo.Seleccionado = mestizo;
        this.setState({
            mestizo: mestizo
        });
    }

    changeEsterilizado(esterilizado) {
        this.configEsterilizado.Seleccionado = esterilizado;
        this.setState({
            esterilizado: esterilizado
        });
    }

    changeEnfermedades(enfermedades) {
        this.configEnfermedades.Seleccionado = enfermedades;
        this.setState({
            enfermedades: enfermedades
        });
    }

    changePPP(ppp) {
        this.configPPP.Seleccionado = ppp;
        this.setState({
            ppp: ppp
        });
    }

    changeChip(chip) {
        this.configChip.Seleccionado = chip;
        this.setState({
            chip: chip
        });
    }

    changeCaracters(caracters) {
        this.setState({
            caracter: caracters
        });
    }

    changeCheckinProtectora(date) {
        // console.log("FormInsertAnimalContainer::changeCheckinProtectora()");
        this.setState({
            fecha_entrada_protectora: (date || new Date()).toISOString().split("T").shift()
            // fecha_entrada_protectora: date.format("YYYY-MM-DD")
        });
    }

    imageChange(id, data) {
        // if (data.isModified) {
        this.setState({
            ...this.state,
            img_principal: data
        });
        // }
    }

    imageAnimalChange(index, data) {
        let imagesAnimals = this.state.imagesAnimals;
        const indexAnimal = imagesAnimals.findIndex(x => x.order === index);
        // if (data.isModified) {

        const dataInsert = {...data, order: index, type: "PUT"};

        if (Object.entries(data).length > 0) {
            if (indexAnimal >= 0) {
                imagesAnimals.splice(indexAnimal, 1, dataInsert)
            } else {
                imagesAnimals.push(dataInsert)
            }
        } else if (indexAnimal >= 0) {
            imagesAnimals.splice(indexAnimal, 1, {order: index, type: "DELETE", isModified: true})
        }


        imagesAnimals = imagesAnimals && imagesAnimals.length > 0
            ? imagesAnimals.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
            : [];

        this.setState({
            ...this.state,
            imagesAnimals
        });
        // }
    }

    validation() {
        //console.log("FormInsertAnimalContainer::validation()")
        let correct = true;
        let errorMessage = "";

        let descripcion = $('#descripcion');
        let name = $('#name');
        let raza = $('#razas');
        let color = $('#colorId');
        let caracters = $('#caracterId');

        /* Validate description */
        if (this.state.descripcion === "") {
            descripcion.removeClass('formInputError').addClass('formInputError');
            correct = false;
            errorMessage += errorMessage === "" ? "Descripción" : ", descripción";
        } else {
            descripcion.removeClass('formInputError')
        }

        /* Validate name */
        if (this.state.nombre === "") {
            name.removeClass('formInputError').addClass('formInputError');
            correct = false;
            errorMessage += errorMessage === "" ? "Nombre" : ", nombre";
        } else {
            name.removeClass('formInputError')
        }

        /* Validate razas */
        if (this.state.raza.length === 0) {
            raza.removeClass('formInputError').addClass('formInputError');
            correct = false;
            errorMessage += errorMessage === "" ? "Raza" : ", raza";
        } else {
            raza.removeClass('formInputError')
        }

        /* Validate colors */
        if (this.state.color.length === 0) {
            color.removeClass('formInputError').addClass('formInputError');
            correct = false;
            errorMessage += errorMessage === "" ? "Colores" : ", colores";
        } else {
            color.removeClass('formInputError')
        }

        /* Validate caracters */
        if (this.state.caracter.length === 0) {
            caracters.removeClass('formInputError').addClass('formInputError');
            correct = false;
            errorMessage += errorMessage === "" ? "Caracter" : ", caracter";
        } else {
            caracters.removeClass('formInputError')
        }

        // Date of entry to the protective
        if (this.state.fecha_entrada_protectora.length === 0) {
            correct = false;
            errorMessage += errorMessage === "" ? "Fecha entrada protectora" : ", fecha entrada protectora";
        }

        if (this.state.img_principal === undefined || Object.entries(this.state.img_principal).length === 0) {
            correct = false;
            errorMessage += errorMessage === "" ? "Imagen principal del animal" : ", imagen principal del animal";
        }

        Alert.closeAll();
        if (errorMessage !== "") {
            Alert.warning('Los siguientes campos son obligatorios: ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });
        }

        return correct;
    }

    // save() {
    //     console.log("FormInsertAnimalContainer::save()")
    //     if (this.validation()) {
    //         this.props.handleChange(this.state);
    //         this.setState({
    //             ...this.state,
    //             animalBackUp: {...this.state}
    //         })
    //     }
    // }

    reset() {
        //console.log("FormInsertAnimalContainer::reset()")
        this.resetState();
        // this.props.resetInfoAnimalDetail("animalsProtectora");
    }

    insert() {
        //console.log("FormInsertAnimalContainer::insert()")
        if (this.validation()) {
            this.props.handleInsert(this.state);
        }
    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    guardarEmailAdoptante() {
        let email_adoptante = $('#email_adoptante');

        let error = false;
        if (this.state.email_adoptante !== "") {
            if (this.state.email_adoptante && this.validateEmail(this.state.email_adoptante.trim())) {
                this.toggleModalEmailAdoptado()
                email_adoptante.removeClass('formInputError')
            } else {
                email_adoptante.removeClass('formInputError').addClass('formInputError');
                error = true
            }
        } else {
            this.toggleModalEmailAdoptado()
        }

        Alert.closeAll();
        if (error) {
            Alert.warning('El email no tiene el formato correcto.', {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle",
                    modal: true
                }
            });
        }

    }

    guardarEmailAcogido() {
        let email_acogido = $('#email_acogido');

        let error = false;
        if (this.state.email_acogido !== "") {
            if (this.state.email_acogido && this.validateEmail(this.state.email_acogido.trim())) {
                this.toggleModalEmailAcogido()
                email_acogido.removeClass('formInputError')
            } else {
                email_acogido.removeClass('formInputError').addClass('formInputError');
                error = true
            }
        } else {
            this.toggleModalEmailAcogido()
        }

        Alert.closeAll();
        if (error) {
            Alert.warning('El email no tiene el formato correcto.', {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle",
                    modal: true
                }
            });
        }

    }

    toggleModalEmailAdoptado() {
        $('#modalEmailAdoptado').modal('toggle')
    }

    toggleModalEmailAcogido() {
        $('#modalEmailAcogido').modal('toggle')
    }

    render() {
        console.log("FormInsertAnimalContainer::render()")
        let show = false;
        if (this.props.estadosAnimal !== undefined && Object.keys(this.props.estadosAnimal).length !== 0
            && this.props.edadesAnimal !== undefined && Object.keys(this.props.edadesAnimal).length !== 0
            && this.props.coloresAnimal !== undefined && Object.keys(this.props.coloresAnimal).length !== 0
            && this.props.tamaniosAnimal !== undefined && Object.keys(this.props.tamaniosAnimal).length !== 0
            && this.props.caractersAnimal !== undefined && Object.keys(this.props.caractersAnimal).length !== 0
            && this.props.razasAnimales[this.state.especie] !== undefined && Object.keys(this.props.razasAnimales[this.state.especie]).length !== 0
            // && Object.keys(this.state).length !== 0
            // && (this.props.insertMode || this.props.infoAnimalDetail && Object.keys(this.props.infoAnimalDetail).length !== 0)
        ) {
            show = true;
        }

        const that = this;
        // const edit = Object.keys(this.props.infoAnimalDetail).length !== 0 && this.props.infoAnimalDetail._id !== undefined;

        if (that.state.galeria_imagenes && that.state.galeria_imagenes.length > 0) {
            that.state.galeria_imagenes = Array.from(Array(IMAGES_ANIMALS_LIMIT), (e, i) => {
                return that.state.galeria_imagenes.findIndex((elem) => elem && elem.pos === i) > -1 ? {...that.state.galeria_imagenes[that.state.galeria_imagenes.findIndex((elem) => elem && elem.pos === i)]} : undefined
            })
        }

        // console.log("FormInsertAnimalContainer::render() -> this.props = " + this.props)
        console.log("FormInsertAnimalContainer::render() -> this.state.especie = " + this.state.especie)
        // console.log("FormInsertAnimalContainer::render() -> this.props.especie = " + this.props.especie)
        console.log("FormInsertAnimalContainer::render() -> this.state.raza = " + this.state.raza)
        // console.log("FormInsertAnimalContainer::render() -> this.props.raza = " + this.props.raza)
        console.log("FormInsertAnimalContainer::render() -> this.configSelectRadioGroupEspecie.selected = " + this.configSelectRadioGroupEspecie.selected)
        console.log("FormInsertAnimalContainer::render() -> this.configRazasMultiselect.seleccionado = " + this.configRazasMultiselect.seleccionado)
        // const especieSeleccionada = (this.props.insertMode) ? this.state.especie : this.props.especie;
        const especieSeleccionada =  this.state.especie
        const razasAnimales = this.props.razasAnimales[especieSeleccionada]
        // const razasSselected = this.configRazasMultiselect.seleccionado
        const razasSeleccionadas = this.state.raza
        console.log("FormInsertAnimalContainer::render() -> razasSeleccionadas = [" + razasSeleccionadas+"]")

        const configSelectRadioGroupEspecie = this.configSelectRadioGroupEspecie
        return (
            <div className="row">
                {show &&
                    <div className="card-block card-detail-animal">
                        <div className="cardInfoDetailShow">
                            {/*<div className="informationDetailDescription">*/}
                            <div style={{maxWidth: 520, margin: "auto"}}>
                                <div className="row justify-content-center withImageDragAndDrop">
                                    {/*<div className="informationDetailDescriptionLeft__withImageRatio">*/}
                                    <ImageDragAndDrop
                                        id="mainPetAnimal"
                                        elementId="mainPetAnimal"
                                        image={this.state.img_principal}
                                        imageChangeMethod={this.imageChange}
                                    />
                                    {/*</div>*/}
                                </div>
                            </div>
                            {/*</div>*/}

                            <div className="page-login__separator"/>
                            <div className="row justify-content-center">
                                <Input
                                    configInput={this.configName}
                                    initialText={this.state.nombre}
                                />
                            </div>
                            <div className="informationDetail ">
                                <ul>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-paw"/>
                                        <span className="raza">Especie: </span>
                                        <SelectRadioGroup
                                            configSelectRadioGroup={this.configSelectRadioGroupEspecie}
                                        />
                                    </li>

                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-paw"/>
                                        <span className="raza">Razas: </span>
                                        {<NewMultiSelect
                                            configSearch={this.configRazasMultiselect}
                                            data={this.props.razasAnimales[especieSeleccionada].map(r => {
                                                return {...r, text: r.label}
                                            })}
                                            seleccionados={razasSeleccionadas}
                                        />}
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-transgender"/>
                                        <span className="sexo">Sexo: </span>
                                        <SelectRadioGroup
                                            configSelectRadioGroup={this.configSelectRadioGroupSexo}
                                            // selected={this.state.sexo}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-paw"/>
                                        <span className="estado">Estado: </span>
                                        <SimpleSelect
                                            configSearch={this.configEstado}
                                            data={this.props.estadosAnimal.map((estado) => {
                                                return estado.text;
                                            })}
                                        />
                                    </li>

                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-tint"/>
                                        <span className="color">Color: </span>
                                        <MultiSelect
                                            configSearch={this.configColores}
                                            data={this.props.coloresAnimal}
                                            seleccionados={this.configColores.seleccionado}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-users"/>
                                        <span className="caracter">Caracter: </span>
                                        <MultiSelect
                                            configSearch={this.configCaracters}
                                            data={this.props.caractersAnimal}
                                            seleccionados={this.configCaracters.seleccionado}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-arrows-alt-v"/>
                                        <span className="tamano">Tamaño: </span>
                                        <SimpleSelect
                                            configSearch={this.configTamanio}
                                            data={this.props.tamaniosAnimal.map((tamanio) => {
                                                return new enumTamanios().convertir(tamanio.text);
                                            })}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-birthday-cake"/>
                                        <span className="edad">Edad: </span>
                                        <SimpleSelect
                                            configSearch={this.configEdad}
                                            data={this.props.edadesAnimal.map((edad) => {
                                                return new enumEdades().convertir(edad.text);
                                            })}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-syringe"/>
                                        <span className="vacunas">Vacunas: </span>
                                        <SwitchButton
                                            configSwitch={this.configVacuna}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-venus-mars"/>
                                        <span className="mestizo">Mestizo: </span>
                                        <SwitchButton
                                            configSwitch={this.configMestizo}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-hand-scissors"/>
                                        <span className="esterilizado">Esterilizado: </span>
                                        <SwitchButton
                                            configSwitch={this.configEsterilizado}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-stethoscope"/>
                                        <span className="enfermedades">Enfermedades: </span>
                                        <SwitchButton
                                            configSwitch={this.configEnfermedades}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-exclamation-triangle"/>
                                        <span className="ppp">PPP: </span>
                                        <SwitchButton
                                            configSwitch={this.configPPP}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-microchip"/>
                                        <span className="chip">Chip: </span>
                                        <SwitchButton
                                            configSwitch={this.configChip}
                                        />
                                    </li>
                                    <li className="column-animal-detail">
                                        <span className="las la-lg la-calendar"/>
                                        <span className="fecha_entrada_protectora">Fecha entrada protectora: </span>
                                        <Datepicker
                                            locale={'es-ES'}
                                            date={this.state.fecha_entrada_protectora}
                                            handleChange={this.changeCheckinProtectora}
                                        />
                                    </li>
                                </ul>
                            </div>
                            <div className="row justify-content-center">
                                <InputTextarea
                                    configTextArea={this.descripcionTextArea}
                                    initialText={this.state.descripcion}
                                />
                            </div>
                            <div className="animalImages borde-superior">
                                <ul>
                                {Array.from(Array(IMAGES_ANIMALS_LIMIT), (e, i) => (
                                        <li key={i}>
                                            <div className="row justify-content-center">
                                                <div className={"div-image-drag-and-drop"}>

                                                    <ImageDragAndDrop
                                                        elementId={i}
                                                        image={
                                                            that.state.galeria_imagenes ? {...that.state.galeria_imagenes[i]} : undefined
                                                        }
                                                        // widtNh={533}
                                                        // height={400}
                                                        imageChangeMethod={that.imageAnimalChange}
                                                    />
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="borde-superior botonera-animal-detail">

                            {/*{this.props.insertMode &&*/}
                                <div>
                                    <button onClick={this.insert} id="btn_back_search"
                                            className="btn btn-outline-primary listing-houses__item-view-link btn-especial">Guardar
                                        nuevo
                                    </button>
                                    <button onClick={this.goAnimalList} id="btn_back_search"
                                            className="btn btn-outline-primary listing-houses__item-view-link">Volver al
                                        listado
                                    </button>
                                </div>
                            {/*}*/}
                        </div>
                        <div>
                            {/*<button type="button" className="btn btn-primary" data-toggle="modal"*/}
                            {/*        data-target="#exampleModalCenter">*/}
                            {/*    Launch demo modal*/}
                            {/*</button>*/}
                            {/*<a onClick={this.activarModalEmailAdoptado} href="#" id="btn_back_search"*/}
                            {/*   className="btn btn-outline-primary listing-houses__item-view-link">Activar modal</a>*/}

                            <div className="modal fade" id="modalEmailAdoptado" tabIndex="-1" role="dialog"
                                 aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h6 className="modal-title" id="exampleModalLongTitle">Enhorabuena! Nos
                                                alegra
                                                mucho que se haya adoptado ya a {this.state.nombre}!</h6>
                                            {/*<button type="button" className="close" data-dismiss="modal" aria-label="Close">*/}
                                            {/*    <span aria-hidden="true">&times;</span>*/}
                                            {/*</button>*/}
                                        </div>
                                        <div className="modal-body">
                                            <div className="">

                                                Introduce el email del adoptante<span
                                                style={{fontSize: "0.8rem"}}>*</span>:
                                            </div>
                                            <div className="row justify-content-center">
                                                <Input
                                                    configInput={this.configEmailAdoptante}
                                                    initialText={this.state.email_adoptante}
                                                />
                                            </div>
                                            <div className="disclaimer-modal">
                                                * Esto nos ayuda a encontrar mejores adoptantes
                                                para tus animales y cuando tengamos disponible el seguimiento de
                                                adopción
                                                podrás
                                                ponerte en contacto más rapidamente con la persona o solicitarle fotos e
                                                información sin perder tiempo
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            {/*<button type="button" className="btn btn-secondary" data-dismiss="modal">Close*/}
                                            {/*</button>*/}
                                            <button onClick={this.guardarEmailAdoptante} type="button"
                                                    className="btn btn-primary">Guardar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal fade" id="modalEmailAcogido" tabIndex="-1" role="dialog"
                                 aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h6 className="modal-title" id="exampleModalLongTitle">Enhorabuena! Nos
                                                alegra
                                                mucho que se haya acogido a {this.state.nombre}!</h6>
                                            {/*<button type="button" className="close" data-dismiss="modal" aria-label="Close">*/}
                                            {/*    <span aria-hidden="true">&times;</span>*/}
                                            {/*</button>*/}
                                        </div>
                                        <div className="modal-body">
                                            <div className="">

                                                Introduce el email de la persona de acogida<span
                                                style={{fontSize: "0.8rem"}}>*</span>:
                                            </div>
                                            <div className="row justify-content-center">
                                                <Input
                                                    configInput={this.configEmailAcogido}
                                                    initialText={this.state.email_acogido}
                                                />
                                            </div>
                                            <div className="disclaimer-modal">
                                                * Esto nos ayuda a encontrar mejores adoptantes
                                                para tus animales y cuando tengamos disponible el seguimiento de
                                                adopción
                                                podrás
                                                ponerte en contacto más rapidamente con la persona o solicitarle fotos e
                                                información sin perder tiempo
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            {/*<button type="button" className="btn btn-secondary" data-dismiss="modal">Close*/}
                                            {/*</button>*/}
                                            <button onClick={this.guardarEmailAcogido} type="button"
                                                    className="btn btn-primary">Guardar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    componentWillMount() {
        if (!this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        }
    }

    componentDidMount() {
        //console.log("FormInsertAnimalContainer::componentDidMount()")
        if (this.props.estadosAnimal === undefined || Object.keys(this.props.estadosAnimal).length === 0) {
            this.props.loadEstadosAnimal();
        }

        if (this.props.edadesAnimal === undefined || Object.keys(this.props.edadesAnimal).length === 0) {
            this.props.loadEdadesAnimal();
        }

        if (this.props.coloresAnimal === undefined || Object.keys(this.props.coloresAnimal).length === 0) {
            this.props.loadColoresAnimal();
        }

        if (this.props.tamaniosAnimal === undefined || Object.keys(this.props.tamaniosAnimal).length === 0) {
            this.props.loadTamaniosAnimal();
        }

        if (this.props.caractersAnimal === undefined || Object.keys(this.props.caractersAnimal).length === 0) {
            this.props.loadCaractersAnimal();
        }

        if (this.props.razasAnimales?.perro === undefined || this.props.razasAnimales.perro.length === 0) {
            this.props.loadRaza("perro");
        }
        if (this.props.razasAnimales?.gato === undefined || this.props.razasAnimales.gato.length === 0) {
            this.props.loadRaza("gato");
        }

        // if (this.props.razasPerro === undefined || Object.keys(this.props.razasPerro).length === 0) {
        //     this.props.loadRaza("Perro");
        // }
        //
        // if (this.props.razasGato === undefined || Object.keys(this.props.razasGato).length === 0) {
        //     this.props.loadRaza("Gato");
        // }

        $(window).on('popstate', function () {
            $('#modalEmailAdoptado').modal('hide');
            $('#modalEmailAcogido').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        });

    }


    componentWillUpdate(nextProps, nextState, nextContext) {
        //console.log("FormInsertAnimalContainer::componentWillUpdate()")
        //
        // if (this.state.animalBackUp) {
        //     nextProps = this.state.animalBackUp;
        // }
        // if (nextProps.nombre) this.state.nombre = nextProps.nombre
        // if (nextProps.descripcion) this.state.descripcion = nextProps.descripcion;
        // if (nextProps.fecha_entrada_protectora) this.state.fecha_entrada_protectora = nextProps.fecha_entrada_protectora;
        // if (nextProps.galeria_imagenes) this.state.galeria_imagenes = nextProps.galeria_imagenes || [];
        // if (nextProps.fecha_registro) this.state.fecha_registro = nextProps.fecha_registro;
        // if (nextProps.img_principal) this.state.img_principal = nextProps.img_principal;
        // if (nextProps.email_adoptante) this.state.email_adoptante = nextProps.email_adoptante
        // if (nextProps.email_acogido) this.state.email_acogido = nextProps.email_acogido
        //
        if (nextProps.especie) {
            console.log("FormInsertAnimalContainer::componentWillUpdate(nextProps.especie = " + nextProps.especie + ")")

            this.configSelectRadioGroupEspecie = {
                ...this.configSelectRadioGroupEspecie,
                selected: nextProps.especie.toLowerCase()
            };
            this.state.especie = nextProps.especie.toLowerCase()
        }

        if (nextProps.raza) {
            console.log("FormInsertAnimalContainer::componentWillUpdate(nextProps.raza = " + nextProps.raza + ")")

            this.configRazasMultiselect = {
                ...this.configRazasMultiselect,
                seleccionado: nextProps.raza
            };
            const razasValues = this.props.razasAnimales[nextProps.especie.toLowerCase()].filter(e => nextProps.raza.includes(e.label)).map(e => e.value)
            this.state.raza = razasValues
        }
        // // debugger
        // if (nextProps.sexo || nextState.sexo) {
        //     //console.log("nextProps.sexo = '" + nextProps.sexo + "'");
        //     //console.log("nextState.sexo = '" + nextState.sexo + "'");
        //     this.configSelectRadioGroupSexo = {
        //         ...this.configSelectRadioGroupSexo,
        //         selected: nextState.sexo
        //     };
        //     this.state.sexo = nextState.sexo
        // }
        // if (nextProps.caracter) {
        //
        //     this.configCaracters = {
        //         ...this.configCaracters,
        //         seleccionado: nextProps.caracter
        //     };
        //     this.state.caracter = nextProps.caracter
        // }
        //
        // if (nextProps.color) {
        //     this.state.color = nextProps.color;
        //
        //     this.configColores = {
        //         ...this.configColores,
        //         seleccionado: nextProps.color
        //     };
        // }
        //
        // if (nextProps.estado) {
        //     this.state.estado = nextProps.estado;
        //
        //     this.configEstado = {
        //         ...this.configEstado,
        //         seleccionado: nextProps.estado
        //     };
        // }
        //
        // if (nextProps.edad) {
        //     this.state.edad = nextProps.edad;
        //
        //     this.configEdad = {
        //         ...this.configEdad,
        //         seleccionado: new enumEdades().convertir(nextProps.edad)
        //     };
        // }
        //
        // if (nextProps.tamano) {
        //     this.state.tamano = nextProps.tamano;
        //
        //     this.configTamanio = {
        //         ...this.configTamanio,
        //         seleccionado: new enumTamanios().convertir(nextProps.tamano)
        //     };
        // }
        //
        // if (nextProps.vacunas) {
        //     this.state.vacunas = nextProps.vacunas;
        //
        //     this.configVacuna = {
        //         ...this.configVacuna,
        //         Seleccionado: nextProps.vacunas
        //     };
        // }
        //
        // if (nextProps.mestizo) {
        //     this.state.mestizo = nextProps.mestizo;
        //
        //     this.configMestizo = {
        //         ...this.configMestizo,
        //         Seleccionado: nextProps.mestizo
        //     };
        // }
        //
        // if (nextProps.esterilizado) {
        //     this.state.esterilizado = nextProps.esterilizado;
        //
        //     this.configEsterilizado = {
        //         ...this.configEsterilizado,
        //         Seleccionado: nextProps.esterilizado
        //     };
        // }
        //
        // if (nextProps.enfermedades) {
        //     this.state.enfermedades = nextProps.enfermedades;
        //
        //     this.configEnfermedades = {
        //         ...this.configEnfermedades,
        //         Seleccionado: nextProps.enfermedades
        //     };
        // }
        //
        // if (nextProps.ppp) {
        //     this.state.ppp = nextProps.ppp;
        //
        //     this.configPPP = {
        //         ...this.configPPP,
        //         Seleccionado: nextProps.ppp
        //     };
        // }
        //
        // if (nextProps.chip) {
        //     this.state.chip = nextProps.chip;
        //
        //     this.configChip = {
        //         ...this.configChip,
        //         Seleccionado: nextProps.chip
        //     };
        // }
    }




    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log("FormInsertAnimalContainer::componentDidUpdate()");
        // if (prevProps.sexo || prevState.sexo) {
        //     console.log("prevProps.sexo = '" + prevProps.sexo + "'");
        //     console.log("prevState.sexo = '" + prevState.sexo + "'");
        //     this.configSelectRadioGroupSexo = {
        //         ...this.configSelectRadioGroupSexo,
        //         selected: prevProps.sexo || prevState.sexo
        //     };
        //     this.state.sexo = nextState.sexo
        // }
    }

    componentWillReceiveProps(nextProps, nextContext) {
    }

}

function mapStateToProps(state, ownProps) {
    //console.log("FormInsertAnimalContainer::mapStateToProps()")
    //console.log("state.especie = " + state.especie)
    //console.log("state.filtersControl.razasAnimales = " + state.filtersControl.razasAnimales)
    // console.log("FormInsertAnimalContainer::mapStateToProps() --> state.filtersControl.razasAnimales.perro[0] = " + JSON.stringify(state.filtersControl.razasAnimales.perro[0]))
    // console.log("FormInsertAnimalContainer::mapStateToProps() --> infoAnimalDetail = " + state[ownProps.animalsControlDetail].infoAnimalDetail?.nombre)
    return {
        // ...state[ownProps.animalsControlDetail].infoAnimalDetail,
        // infoAnimalDetail: state[ownProps.animalsControlDetail].infoAnimalDetail,
        razasAnimales: state.filtersControl.razasAnimales || {},
        // razasPerro: (state.filtersControl.razasPerro) ? state.filtersControl.razasPerro : [],
        // razasGato: (state.filtersControl.razasGato) ? state.filtersControl.razasGato : [],
        estadosAnimal: state.filtersControl.estadosAnimal,
        edadesAnimal: state.filtersControl.edadesAnimal,
        coloresAnimal: state.filtersControl.coloresAnimal,
        tamaniosAnimal: state.filtersControl.tamaniosAnimal,
        caractersAnimal: state.filtersControl.caractersAnimal,
        access: state.access
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps,
    {
        loadEstadosAnimal,
        loadEdadesAnimal,
        loadColoresAnimal,
        loadTamaniosAnimal,
        loadCaractersAnimal,
        loadRaza,
        // changeEspecieInfoAnimalDetail,
        // resetInfoAnimalDetail
    }
)(FormInsertAnimalContainer)
